const initialState = {
  oneWay: false,
  roundTrip: false,
  new_go_date: null,
  new_back_date: null,
};

const isThreeDaysSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_IS_THREE_DAYS_SEARCH':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default isThreeDaysSearchReducer;
